import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { ApplicationPackage } from './application-package.service';
import { PermitProjectFacilityAopService, ProjectFacilityAnnualOperatingPlanApi } from './permit-project-facility-aop.service';
import { DblistService } from './dblist.service';

@Injectable({
  providedIn: 'root'
})
export class PermitProjectFacilityService {

  // This is the list of all Facilities, used by the AOP group in the new/existing permit page
  private facilitiesSource = new BehaviorSubject<Facility[]>([]);
  currentFacilities = this.facilitiesSource.asObservable();

  // This is the list of Facilities by App Id, used by the facility-form at the top of the new/existing permit page
  private facilitiesByAppIdSource = new BehaviorSubject<Facility[]>([]);
  currentFacilitiesByAppId$ = this.facilitiesByAppIdSource.asObservable();

  // This is the list of Facilities by AOP Id, used by the facility-form at the top of the new/existing permit page
  private facilitiesByAopIdSource = new BehaviorSubject<Facility[]>([]);
  currentFacilitiesByAopId$ = this.facilitiesByAopIdSource.asObservable();

//   // This is a single Facility by Facility Id, used by the new-permit component to grab the associated App Id
//   private facilityByFacilityIdSource = new BehaviorSubject<Facility[]>([]);
//   currentFacilityByFacilityId = this.facilityByFacilityIdSource.asObservable();

  // This is the selected Facility from the AOP-group in the new/exising permit page
  private facilitySource = new BehaviorSubject<Facility>(null);
  currentFacility = this.facilitySource.asObservable();

  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string,
    private pfaopService: PermitProjectFacilityAopService,
    private dbListService: DblistService
  ) {}

  //getFacilities(pod: number, year: number) {
  //  this.http.get<Facility[]>(`${this.baseUrl}api/projectfacility/search?PermitPointOfDiversionId=${pod}&PermitYear=${year}`).subscribe(
  getFacilities(pod: number) {
    this.http.get<Facility[]>(`${this.baseUrl}api/projectfacility/search?PermitPointOfDiversionId=${pod}`).subscribe(
      result => {
        if (result) {
          this.changeFacilities(result);
        }
        this.dbListService.getListFacilityType();
        this.dbListService.getListPerAcreFootCostBasisForRecharge();
        this.dbListService.getListRecorderType();
        this.dbListService.getListDeviceRecordingInterval();
      },
      error => console.error(error)
    );
  }

  getFacilitiesByAopId(aopId: number) {
    this.http.get<Facility[]>(`${this.baseUrl}api/projectfacility/search?PermitAnnualOperatingPlanId=${aopId}`).subscribe(
      result => {
        if (result) {
          this.changeFacilitiesByAopId(result);
        }
        this.dbListService.getListFacilityType();
        this.dbListService.getListPerAcreFootCostBasisForRecharge();
        this.dbListService.getListRecorderType();
        this.dbListService.getListDeviceRecordingInterval();
      },
      error => console.error(error)
    );
  }

//   getFacilityByFacilityId(facilityId: number) {
//     this.http.get<Facility[]>(`${this.baseUrl}api/facility/?Id=${facilityId}`).subscribe(
//       result => {
//         if (result) {
//           this.changeFacilityByFacilityId(result);
//         }
//       },
//       error => console.error(error)
//     );
//   }

  postFacility(formData: Facility, applicationPackage: ApplicationPackage, aopId: number) {
    let postData = formData;
    postData.permitPointOfDiversionId = applicationPackage.permitPointOfDiversionId;
    postData.ownerAppropriatorId = applicationPackage.appropriatorId;
    this.http.post<Facility>(`${this.baseUrl}api/projectfacility/`, postData).subscribe(
      response => {
        if (response) {
          //this.getFacilities(applicationPackage.permitPointOfDiversionId);
          this.getFacilitiesByAopId(aopId);
          // Creating a new, blank PFAOP every time a Project Facility is created
          let pfaop = {} as ProjectFacilityAnnualOperatingPlanApi;
          pfaop.permitAnnualOperatingPlanId = aopId;
          pfaop.projectFacilityId = response.projectFacilityId;
          pfaop.projectFacilitySponsorApiList = [];
          pfaop.projectFacilityInstrumentApiList = [];
          this.pfaopService.postPfaop(pfaop);
          //
        }
      },
      error => console.error(error)
    );
  }

  putFacility(formData: Facility, applicationPackage: ApplicationPackage, aopId: number) {
    this.http.put<Facility>(`${this.baseUrl}api/projectfacility/`, formData).subscribe(
      response => {
        if (!!response) {
          //this.getFacilities(applicationPackage.permitPointOfDiversionId);
          this.getFacilitiesByAopId(aopId);
          this.pfaopService.getPfaops(aopId);
        }
      },
      error => console.error(error)
    );
  }

  putUpdateFacilityInUse(data: ProjectFacilityInUseApi[]) {
    if (!data || data.length == 0) {
      return;
    }
    var appId = data[0].applicationPackageId; 
    var permitId = data[0].permitAnnualOperatingPlanId;
    this.http.put<ProjectFacilityInUseApi[]>(`${this.baseUrl}api/projectfacility/UpdateFacilityInUse`, data).subscribe(
      response => {
        if (response) {
          this.getFacilitiesByAopId(permitId);
          this.pfaopService.getPfaops(permitId);
        }
      },
      error => console.error(error)
    );
  }

  deleteFacility(formData: Facility, applicationPackage: ApplicationPackage, aopId: number) {
    var id: number = formData.projectFacilityId;
    this.http.delete(`${this.baseUrl}api/projectfacility/${formData.projectFacilityId}`).subscribe(
      response => {
        if (!!response) {
          //this.getFacilities(applicationPackage.permitPointOfDiversionId);
          this.getFacilitiesByAopId(aopId);
          this.pfaopService.getPfaops(aopId);
        }
      },
      error => console.error(error)
    );
  }

  // This is the list of all Facilities, used by the AOP-group in the new/existing permit page
  changeFacilities(facilities) {
    this.facilitiesSource.next(facilities);
  }

  // This is the list of Facilities by PermitAOP Id, used by the Permit application page view
  changeFacilitiesByAopId(facilities) {
    this.facilitiesByAopIdSource.next(facilities);
  }

   // This is the list of Facilities by App Id, used by the facility-form at the top of the new/existing permit page
  changeFacilitiesByAppId(facilities) {
    this.facilitiesByAppIdSource.next(facilities);
  }

//   // This is a single Facility by Facility Id, used by the new-permit component to grab the associated App Id
//   changeFacilityByFacilityId(facility) {
//     this.facilityByFacilityIdSource.next(facility);
//   }

  // This is the selected Facility from the AOP-group in the new/exising permit page
  changeFacility(facility) {
    this.facilitySource.next(facility);
  }

}

export interface Facility {
  projectFacilityId: number,
  name: string,
  description: string,
  ownerAppropriatorId: number,
  ownerAppropriatorName: string,
  permitPointOfDiversionId: number, // = projectFacility.PermitPointOfDiversionId,
  permitPointOfDiversionName: string,
  diversionEndDate: any, // = projectFacility.DiversionEndDate,
  deliveryPointLatitude: number, // = projectFacility.LocationDeliveryLatitude,
  deliveryPointLongitude: number, // = projectFacility.LocationDeliveryLongitude,
  disabled: string, // Used to disable using a project facility more than once per year for its POD
  listFacilityTypeId: number,
  listFacilityName?: string,
  isDeleted: boolean,
  inUse: boolean,
}

export interface ProjectFacilityInUseApi {
  applicationPackageId: number,
  permitAnnualOperatingPlanId: number,
  projectFacilityId: number,
  inUse: boolean,
}